import React from "react"
import { Typography } from "antd"
import { getTechnology } from "../../lib/prismic/mapData"
import { groupBy, orderBy } from "lodash"
import moment from "moment/moment"
import { TechnologyCourses } from "./TechnologyCourses"
import { CoursesList } from "../CoursesList/CoursesList"
import { PrismicDocument } from "@prismicio/types"
import { PrismicCourseOrContentfulProduct } from "../../lib/contentful/PrismicCourseOrContentfulProduct"
import { isOldPrismicCourse } from "../../lib/prismic/getCourse"
import { Entry } from "contentful"
import { TypeProductEntitySkeleton } from "../../lib/contentful/ContentfulVzdelanibudoucnostiTypes"
import { ProductsColorsItem } from "../../lib/contentful/product/getAllProducts"
import { css } from "@emotion/react"
import { md, sm, xs } from "../../styles/mediaQuery"

export const GroupedCoursesByTechnology = ({ courses, children, productsColors, moreInfo }: Props) => {
  const groupedOpenCoursesByTechnology = groupBy(courses, (d) =>
    isOldPrismicCourse(d)
      ? (d as PrismicDocument<any>).data.technology.uid
      : (d as Entry<TypeProductEntitySkeleton, undefined, string>).fields.technology?.[0].sys.id
  )
  const groupedOpenCoursesByTechnologyEntries = Object.entries(groupedOpenCoursesByTechnology)

  const sortedGroupedOpenCoursesByTechnologyEntries = groupedOpenCoursesByTechnologyEntries
    .sort(([keyA], [keyB]) => {
      if (keyA === undefined || keyA === "undefined") return 1
      if (keyB === undefined || keyB === "undefined") return -1
      return 0
    })
    .sort(([, aCourses], [, bCourses]) => bCourses.length - aCourses.length)

  return (
    <>
      {sortedGroupedOpenCoursesByTechnologyEntries.length > 0 ? (
        <>
          <Typography.Title
            level={2}
            css={css`
              position: relative;

              &:after {
                position: absolute;
                content: "";
                background-image: url("/images/xichtici/xichtik_1_py.svg");
                background-position: center;
                background-repeat: no-repeat;
                width: 100px;
                height: 100px;
                top: 0;
                left: 0;
                transform: rotate(-10deg) translate(-40px, -100px);

                ${md} {
                  width: 80px;
                  height: 80px;
                  transform: rotate(-10deg) translate(-11px, -74px);
                }
              }
            `}>
            Nerdi budoucnosti? Jasně – přihlas se a staň se jedním z nás!
          </Typography.Title>

          {children || null}

          {sortedGroupedOpenCoursesByTechnologyEntries.map(([slug, documents]) => {
            const orderedDocuments = orderBy(documents, (d) =>
              moment(
                isOldPrismicCourse(d)
                  ? (d as PrismicDocument<any>).data.first_course_day
                  : (d as Entry<TypeProductEntitySkeleton, undefined, string>).fields.courseFirstDay
              )
            )
            const firstDocument = documents[0]
            if (!firstDocument) {
              return null
            }

            const technology = getTechnology(firstDocument)
            if (!technology) {
              return null
            }

            return (
              <TechnologyCourses key={slug} technology={technology} technologyDetailUrl={`/pocitacove-krouzky-pro-deti/${technology.slug}`} moreInfo={moreInfo}>
                <CoursesList
                  courses={orderedDocuments || []}
                  productsColors={productsColors}
                  withSubCourse={false}
                  whenOnHeader={true}
                  simpleLayout={true}
                  informationOnly={true}
                  carouselWidth={true}
                  colProps={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 6 }}
                />
              </TechnologyCourses>
            )
          })}
        </>
      ) : null}
    </>
  )
}

interface Props {
  title: React.ReactNode
  courses: PrismicCourseOrContentfulProduct[]
  children?: React.ReactNode
  productsColors?: ProductsColorsItem[]
  moreInfo?: boolean
}
